import { render, staticRenderFns } from "./ShowModule.vue?vue&type=template&id=41156bf3&scoped=true"
import script from "./ShowModule.vue?vue&type=script&lang=js"
export * from "./ShowModule.vue?vue&type=script&lang=js"
import style0 from "./ShowModule.vue?vue&type=style&index=0&id=41156bf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41156bf3",
  null
  
)

export default component.exports